import React from "react";
import "./App.css";
import profilePic from "./assets/profile_pic.jpg";
import CarouselComponent from "./CarouselComponent";
import ChatWidget from "./ChatWidget";
import Signup from "./Signup";
import BlogPost from "./blogpost";
import BlogContent from "./BlogContent";
import ChatHistory from "./ChatHistory";

const API_BASE = window.location.origin;

function App() {
  
  const [view, setView] = React.useState("home");
  const [loggedInUser, setLoggedInUser] = React.useState(localStorage.getItem("loggedInUser"));
  const [selectedPost, setSelectedPost] = React.useState(null);
  const [blogPosts, setBlogPosts] = React.useState([]);
  


    const renderContent = () => {
        switch (view) {
            case "home":
                return (
                    <React.Fragment>
                        <div className="left-section">
                            <img src={profilePic} alt="Profile" />
                            <p>Young Beum, Cho</p>
                            <span>Birthdate: March 1, 1995</span>
                            <span>Contact: c.youngbeum@wustl.edu</span>
                            <span>
                                LinkedIn:{" "}
                                <a href="https://www.linkedin.com/in/beeybcho" target="_blank" rel="noopener noreferrer">
                                    {" "} https://www.linkedin.com/in/beeybcho{" "}
                                </a>
                            </span>
                            {loggedInUser ? (
                                <React.Fragment><br></br><br></br><br></br>
                                    <p>Welcome, {loggedInUser}!</p>
                                    <button className="logout-button" onClick={handleLogout} style={{ backgroundColor: "red" }}>Log out</button>
                                      {localStorage.getItem("userRole") === "manager" && (
                                      <button className="create-post-button" onClick={() => setView("blogpost")}>Create Post</button>)
                                      }
                                      <button className="chat-history-button" onClick={() => setView("chathistory")}>Chat History</button>
                                </React.Fragment>
                                
                            ) : (
                                <div className="login-section">
                                    <input type="text" placeholder="User ID" className="login-input"/>
                                    <input type="password" placeholder="Password" className="login-input" />
                                    <div className="button-container">
                                        <button className="login-button" onClick={handleLogin}> Login </button>
                                        <button className="signup-button" onClick={() => setView("signup")}> Sign up </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="middle-section">
                          
                          <div style={{ marginBottom: "40px" }}>
                        <CarouselComponent /></div>
                        <h2 className="managers-posts-title" style={{ marginTop: "40px" }}>Manager's Posts</h2>
                          <div className="blog-posts">
                            {blogPosts.map((post) => (
                              <div key={post.id} className="blog-post-container">
                                <p
                                  className="blog-post-title"
                                  onClick={() => {
                                    setSelectedPost(post.id);
                                    setView("blogcontent");
                                  }}
                                >
                                  {post.title}
                                </p>
                                {loggedInUser && localStorage.getItem("userRole") === "manager" && (
                                <button className="edit-post-button" onClick={() => {setSelectedPost(post.id); setView("editpost");}}
                                >Edit</button>)}

                                {loggedInUser && localStorage.getItem("userRole") === "manager" && (
                                  <button className="delete-post-button" onClick={() => handleDeletePost(post.id)}>Delete</button>
                                )}
                              </div>
                            ))}
                          </div>


                        </div>
                        <div className="right-section">
                          <ChatWidget loggedInUser={loggedInUser} />
                        </div>
                    </React.Fragment>
                );
            case "signup":
                return <Signup setView={setView} />;
            case "blogpost":
              return (
                <React.Fragment>
                  <div className="left-section"></div>
                  <div className="middle-section">
                    <BlogPost reloadBlogPosts={reloadBlogPosts} />
                  </div>
                  <div className="right-section"></div>
                </React.Fragment>
              );
            case "editpost":
              return (
                <React.Fragment>
                  <div className="left-section"></div>
                  <div className="middle-section">
                    <BlogPost
                      editMode
                      postId={selectedPost}
                      reloadBlogPosts={reloadBlogPosts}
                    />
                  </div>
                  <div className="right-section"></div>
                </React.Fragment>
              );
            case "blogcontent":
              return (
                <React.Fragment>
                  <div className="left-section"></div>
                  <div className="middle-section">
                    <BlogContent postId={selectedPost} />
                  </div>
                  <div className="right-section"></div>
                </React.Fragment>
              );
              
            case "chathistory":
              return (
                <React.Fragment>
                  <div className="left-section"></div>
                  <div className="middle-section">
                    <ChatHistory loggedInUser={loggedInUser} />
                  </div>
                  <div className="right-section"></div>
                </React.Fragment>
              );
  
            default:
                return <div>Page not found</div>;
        }
    };

    const handleLogin = async () => {
      const userId = document.querySelector(".login-input[type='text']").value;
      const userPass = document.querySelector(".login-input[type='password']").value;
      try {
        const response = await fetch(`${API_BASE}/api/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username: userId, password: userPass }),
        });
        const result = await response.json();
          if (result.success) {
              setLoggedInUser(result.username);
              localStorage.setItem("loggedInUser", result.username);
              localStorage.setItem("userRole", result.user_role);
              window.location.reload();
          } else {
              alert("Incorrect Username or/and Password");
          }
      } catch (error) {
        console.error("Error during login:", error);
      }
    };
    
    const handleLogout = () => {
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("userRole");
      setLoggedInUser(null);
      window.location.reload();
    };

    const fetchBlogPosts = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/fetch_posts`);
        const data = await response.json();
        setBlogPosts(data.posts);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      }
    };

    const reloadBlogPosts = () => {
      setBlogPosts([]);
      fetchBlogPosts();
    };

    const handleDeletePost = async (postId) => {
      try {
          await fetch(`${API_BASE}/api/delete_post/${postId}`, {
              method: "DELETE",
          });
          reloadBlogPosts();
      } catch (error) {
          console.error("Error deleting post:", error);
      }
  };
  
    
  
    React.useEffect(() => {
      fetchBlogPosts();
    }, []);

    return <div className="App">{renderContent()}</div>;
}

export default App;
